import Http from '@/services/http';
import {
  DiagnosticsConfigurationsRequest,
  DiagnosticsConfigurationsResponse,
  UpdateDiagnosticsConfigurationsRequest,
  DiagnosticClassificationDetail,
  DiagnosticDetailsByAssetRequest,
} from 'sigma-mappings';

const urls = {
  chromaClassifications: '/engenharia/chroma/diagnosticos/classificacoes',
  getDetails: '/engenharia/chroma/diagnosticos/classificacao/detalhes',
  getEngineeringModuleClassifications: engineeringModule => `/engenharia/${engineeringModule}/diagnosticos/classificacoes`,
  getEngineeringModuleDetails: engineeringModule => `/engenharia/${engineeringModule}/diagnosticos/classificacao/detalhes`,
};

export default {
  getChromatographyClassifications(params) {
    const http = new Http();
    const mappedParams = new DiagnosticsConfigurationsRequest(params);
    return http.post(urls.getEngineeringModuleClassifications('cromatografia'), mappedParams)
      .then(({ data }) => new DiagnosticsConfigurationsResponse(data));
  },
  getPhysicalChemicalClassifications(params) {
    const http = new Http();
    const mappedParams = new DiagnosticsConfigurationsRequest(params);
    return http.post(urls.getEngineeringModuleClassifications('fisico-quimico'), mappedParams)
      .then(({ data }) => new DiagnosticsConfigurationsResponse(data));
  },
  getOscillographyAnalysisClassifications(params) {
    const http = new Http();
    const mappedParams = new DiagnosticsConfigurationsRequest(params);
    return http.post(urls.getEngineeringModuleClassifications('analise-oscilografia'), mappedParams)
      .then(({ data }) => new DiagnosticsConfigurationsResponse(data));
  },
  getChromaDetails(params) {
    const http = new Http();
    const mappedParams = new DiagnosticDetailsByAssetRequest(params);
    return http.post(urls.getDetails, mappedParams)
      .then(({ data }) => data.map(item => new DiagnosticClassificationDetail(item)));
  },
  getOscillographyAnalysisDetails(params) {
    const http = new Http();
    const mappedParams = new DiagnosticDetailsByAssetRequest(params);
    return http.post(urls.getEngineeringModuleDetails('analise-oscilografia'), mappedParams)
      .then(({ data }) => data.map(item => new DiagnosticClassificationDetail(item)));
  },
  putConfigurations(params) {
    const http = new Http();
    const mappedParams = new UpdateDiagnosticsConfigurationsRequest(params);
    return http.put(urls.chromaClassifications, mappedParams)
      .then(({ data }) => data);
  },
  putOscillographyAnalysisConfigurations(params) {
    const http = new Http();
    const mappedParams = new UpdateDiagnosticsConfigurationsRequest(params);
    return http.put(urls.getEngineeringModuleClassifications('analise-oscilografia'), mappedParams)
      .then(({ data }) => data);
  },
};
